module.exports = __webpack_public_path__ + "static/media/podcasters-mobile-logo.9e056c16.svg";